<template>
  <div id="contenedor-contrato-firma-tool-bar">
    <v-toolbar flat color="transparent">
      <v-spacer></v-spacer>
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Nueva"
        iconText="mdi-plus"
        tipo="agregar"
        @click="nueva">
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoFirmasToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    nueva() {
      this.$emit('nuevaFirma');
    },
  },
};
</script>

<style lang="scss">

</style>
